import type { DatoveSchrankyDatovaZpravaDto } from '@gov-nx/api';
import {
	loadDataBoxMessagePoQuery,
	loadDataBoxMessagesQuery,
	useAxiosInstance,
	usePoQuery,
} from '@gov-nx/api';
import type { GovError } from '@gov-nx/core/app';
import type { Nullable } from '@gov-nx/core/types';

export interface DataBoxMessagesLoaderProps {
	onError: (error: GovError) => void;
	messageIds: number[];
}

export const useDataBoxMessagesLoader = ({
	messageIds,
	onError,
}: DataBoxMessagesLoaderProps) => {
	const { axiosInstance } = useAxiosInstance();
	return usePoQuery<DatoveSchrankyDatovaZpravaDto[]>({
		queryKey: ['data-box-messages', messageIds],
		queryFn: () => loadDataBoxMessagesQuery(axiosInstance, messageIds),
		onError,
		enabled: !!messageIds.length,
		retry: 0,
		refetchOnWindowFocus: false,
	});
};

export interface DataBoxMessagePoLoaderProps {
	onError?: (error: GovError) => void;
	messageId: Nullable<number>;
}

export const useDataBoxMessagePoLoader = ({
	messageId,
	onError,
}: DataBoxMessagePoLoaderProps) => {
	const { axiosInstance } = useAxiosInstance();
	const query = usePoQuery<DatoveSchrankyDatovaZpravaDto>({
		queryKey: ['data-box-message', messageId],
		queryFn: () =>
			loadDataBoxMessagePoQuery(axiosInstance, messageId as number),
		onError,
		enabled: !!messageId,
		retry: 0,
		refetchOnWindowFocus: false,
	});

	return { query };
};
